var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12 col-md-4 mb-3 mb-md-0" }, [
          _c("div", { staticClass: "display-1" }, [
            _vm._v(_vm._s(_vm.reportTitle(true)))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-8 align-right text-md-right" },
          [
            _vm.hasFilterProducts()
              ? _c(
                  "div",
                  { staticClass: "d-inline-block" },
                  [
                    _vm._v("Products:\n        "),
                    _c("filter-products", {
                      staticClass: "d-inline-block mb-1",
                      attrs: {
                        fieldData: _vm.chartProductFilters,
                        widgetType: "select",
                        widgetStyle: "colorful"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-inline-block" },
              [
                _vm._v("Date Control:\n        "),
                _c("filter-daterange", {
                  staticClass: "d-inline-block mb-1",
                  attrs: { fieldData: _vm.chartDateFiltersPrimary }
                }),
                _vm._v(" "),
                _c("filter-daterange", {
                  staticClass: "d-inline-block",
                  attrs: { fieldData: _vm.chartDateFiltersSecondary }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("summary-blocks", { attrs: { tableData: _vm.dataSummary } }),
      _vm._v(" "),
      _c("div", { staticClass: "row mx-0 py-2 table-heading rounded-top" }, [
        _c("div", { staticClass: "col-12 col-md-5 my-auto" }, [
          _c("div", [_vm._v(_vm._s(_vm.reportTitle()))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-md-7 align-md-right text-md-right my-auto"
          },
          [
            _c(
              "b-form-group",
              { staticClass: "search-box-admin mb-0 mt-sm-2 mt-md-0 d-inline" },
              [
                _c(
                  "b-input-group",
                  [
                    _c(
                      "b-input-group-text",
                      { attrs: { slot: "prepend" }, slot: "prepend" },
                      [_c("i", { staticClass: "fas fa-search" })]
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "search-text-box-admin",
                      attrs: { placeholder: "Search Table" },
                      model: {
                        value: _vm.filter,
                        callback: function($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasSecondaryDimension
              ? _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "outline-light" },
                    on: {
                      click: function($event) {
                        return _vm.resetDimensions()
                      }
                    }
                  },
                  [_vm._v("Clear Dimension")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-inline-block ml-3" }, [
              _vm._v("Filter " + _vm._s(_vm.reportTitle()) + ":")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nav-item-collapse d-inline-block",
                class: { active: _vm.is_showing("dimension-filters-list") },
                attrs: {
                  href: "javascript:void();",
                  id: "dimension-filters",
                  "data-target": "#dimension-filters-list"
                },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.toggle_collapse($event)
                  },
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggle_collapse($event)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-sliders-h ml-2 secondary-icon" })]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row mx-0 py-3 border-bottom",
          class: {
            collapse: true,
            show: _vm.is_showing("dimension-filters-list")
          },
          attrs: {
            id: "dimension-filters-list",
            "data-target": "#dimension-filters"
          }
        },
        [
          _c("div", { staticClass: "col-12" }, [
            !!_vm.persistentDimension
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("div", [_vm._v("Secondary Dimension:")]),
                      _vm._v(" "),
                      _c("filter-dimension", {
                        attrs: { fieldData: _vm.chartDimensionFilters }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("filter-filters", {
                    attrs: {
                      chartFiltersFilters: _vm.chartFiltersFilters,
                      chartDimensionFilters: _vm.chartDimensionFilters
                    },
                    on: { resetFilters: _vm.resetFilters }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          true
            ? _c("div", { staticClass: "animated fadeIn" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _c("div", { staticClass: "card rounded-bottom" }, [
                      _c(
                        "div",
                        { staticClass: "card-body", attrs: { id: "report" } },
                        [
                          _c("datatable-block", {
                            attrs: {
                              dataFilters: _vm.dataFilters,
                              filter: _vm.filter,
                              persistentDimension: _vm.persistentDimension,
                              tableData: _vm.reportDataPrimary,
                              tableDataSecondary: _vm.reportDataSecondary,
                              chartFiltersFilters: _vm.chartFiltersFilters,
                              dimensionProperty: this.dimensionProperty,
                              isLoading: _vm.isLoading
                            },
                            on: {
                              setPersistentDimension: _vm.setPersistentDimension
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4ffd780", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4ffd780","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/p_admin/Reports.vue
// module id = null
// module chunks = 